function isDesktopMp4Url(url) {
  return /\.mp4$/i.test(String(url || '').split(/[?#]/, 1)[0])
}

module.exports = { isDesktopMp4Url }
